import React from 'react'

const WebDesignCore = ({vertical}) => {
  return (
    <div>
         <div className='row  d-flex justify-content-center'>
          {vertical.map((val,i)=>(
            <div className='col-md-3 col-lg-2 col-sm-4  col-6 mb-4' key={i}>

            <div className={`rounded-3 bg-black d-flex h-100 flex-column justify-content-between p-3 position-relative ${val.line} `}  >
              <img src={val.icon} alt="" style={{width:52,height:52}} />
              <h3 className="h3-para mt-2 text-center text-white fw-semibold">{val.title}</h3>
            </div>
            </div>
          ))}
        </div>
    </div>
  )
}

export default WebDesignCore